import React from 'react';

import AdminEducationApplicationReportListContainer from '@src/components/externalEducationApplication/AdminEducationApplicationReportListContainer';

const AdminEducationApplicationReportPage = () => <AdminEducationApplicationReportListContainer />;

export default AdminEducationApplicationReportPage;
